console.log('js/countdown.js -> v0.1.0');
$(function(){
	if ( $('.js-payment-countdown').length ) {
		var expirationTime = $('.js-payment-expiration').val()
		var expireDate = moment(expirationTime, 'YYYY-MMM-DD kk:mm:ss').toDate();
		// Adjust to local time
		var localExpireDate = new Date(expireDate.getTime() - expireDate.getTimezoneOffset() * 60000);
		var countDownDate = localExpireDate.getTime();
		var expiredText = ($('.js-payment-countdown').data('expired-text') ? $('.js-payment-countdown').data('expired-text') : 'This payment form is expired');

		var x = setInterval(
			function() {
				var now = new Date().getTime();
				var distance = countDownDate - now;

				var days = Math.floor(distance / (1000 * 60 * 60 * 24));
				var totalHours = Math.floor((distance / (1000 * 60 * 60)));
				var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
				var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
				var seconds = Math.floor((distance % (1000 * 60)) / 1000);

				var pad = function(input) {return input < 10 ? "0" + input : input;}; // Adds 0 to the left

				$('.js-payment-countdown').text(pad(totalHours) + ":" + pad(minutes) + ":" + pad(seconds));


				// The experiment shouldnt appear if the count down is finished.
				// Leaving the message below in case of unlikely errors.
				if (distance < 0) {
					clearInterval(x);
					$('.js-payment-countdown').parent().text(expiredText);
				}
			},
			1000
		);
	}
});
